import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { Button, Alert, Row, Col, Image, Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom';
import bannerImg from "../assets/images/banner-img.png";
import Styles from "../styles/Modules/ProjectReport.module.css";


// =============   COMPONENTS IMPORTS  ===============
import Header from '../Components/PageComponent/Layout/Header';
import Footer from '../Components/PageComponent/Layout/Footer';
import HeroSlider from '../Components/SliderComponent/HeroSlider';

// =============   ICONS IMPORTS  ===============
import { IoIosCreate, IoMdBulb, IoIosLeaf, IoIosRocket, IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaQuestion } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { FaGear } from "react-icons/fa6";
import growthIcon from "../assets/images/icons/growth.png";
import lightBulbIcon from "../assets/images/icons/lightbulb.png";
import shieldIcon from "../assets/images/icons/shield.png";
import shuttleIcon from "../assets/images/icons/shuttle.png";
import parcelIcon from "../assets/images/icons/parcel.png";
import cubesIcon from "../assets/images/icons/cubes.png";
import userIcon from "../assets/images/icons/user.png";
import packageIcon from "../assets/images/icons/package.png";
import locationIcon from "../assets/images/icons/location.png";
import cardIcon from "../assets/images/icons/card.png";
import verifyIcon from "../assets/images/icons/verify.png";
import newtworkIcon from "../assets/images/icons/social-network.png";
import orderIcon from "../assets/images/icons/order.png";
import supplierBanner from "../assets/images/banner/supplier-promotion-banner.png";
import supplierMobileBanner from "../assets/images/banner/supplier-promotion-mobile-banner.png";
import axios from 'axios';
export default function Home() {
    const { t } = useTranslation();

    const { AuthReducer: { loading, errors, isAuthenticated } } = useSelector(state => state)
    const router = useNavigate()
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [searchList, setSearchList] = useState([]);
    const [page, setPage] = useState(1);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [supplierStats,setSupplierStats] = useState([])
    useEffect(()=>{
     axios.get('/api/supplier/get-stats').then((res)=>{
        setSupplierStats(res?.data)
     }).catch((err)=>console.log(err))  
    },[])

    const faqData = [
        {
            id: '1',
            question: 'मुख्यमंत्री युवा उद्यमी विकास अभियान (सीएम युवा) क्या है?',
            answer: '<p>मुख्यमंत्री युवा उद्यमी विकास अभियान उत्तर प्रदेश सरकार की एक प्रमुख योजना है, जिसका उद्देश्य अगले 10 वर्षों में 10 लाख स्वरोजगार के अवसर प्रदान करना है। इस योजना के तहत माइक्रो और स्मॉल यूनिट्स की स्थापना कर युवाओं को आत्मनिर्भर बनाने पर जोर दिया गया है। यह योजना युवाओं को वित्तीय सहायता, कौशल विकास, और व्यवसायिक सहायता प्रदान करती है|</p>'
        },
        {
            id: '2',
            question: 'सीएम युवा के लिए आवेदन करने के लिए पात्रता मानदंड क्या हैं?',
            answer: `<ul class="p-0 m-0">
            <li>आवेदक उत्तर प्रदेश का मूल निवासी होना चाहिए।</li>
            <li>आयु: 21 से 40 वर्ष।</li>
            <li>न्यूनतम शिक्षा: 8वीं पास [इंटरमीडिएट (कक्षा 12) या समकक्ष योग्यता को प्राथमिकता ]।</li>
            <li>आवेदक ने सरकार द्वारा प्रायोजित कौशल विकास कार्यक्रम जैसे विश्वकर्मा श्रम सम्मान योजना, एक जिला एक उत्पाद (ओडीओपी) प्रशिक्षण एवं टूलकिट योजना, अनुसूचित जाति/अनुसूचित जनजाति/अन्य पिछड़ा वर्ग प्रशिक्षण योजना या उत्तर प्रदेश कौशल विकास मिशन के तहत प्रशिक्षण पूरा किया हो।</li>
            <li>वैकल्पिक रूप से, उनके पास किसी मान्यता प्राप्त संस्थान से कौशल संबंधी क्षेत्र में प्रमाण पत्र, डिप्लोमा या डिग्री होनी चाहिए।</li>
            <li>आवेदक ने प्रधानमंत्री स्वनिधि योजना को छोड़कर किसी अन्य सरकारी योजना के तहत ब्याज या पूंजी सब्सिडी का लाभ न लिया हो।</li>
          </ul>`
        },
        {
            id: '3',
            question: 'सीएम युवा के प्रथम चरण तहत क्या वित्तीय सहायता प्रदान की जाती है?',
            answer: `<div>
            <strong>पहला चरण (Phase 1):</strong>
            <ul class="p-0 m-0">
              <li>परियोजना लागत ₹5 लाख तक: 4 वर्षों के लिए ₹5 लाख तक की परियोजना लागत पर 100% ब्याज सब्सिडी और कोलेटरल गारंटी-मुक्त ऋण।</li>
              <li>₹5 से अधिक ₹10 लाख तक: अतिरिक्त राशि का वित्तपोषण लाभार्थी को स्वयं करना होगा।</li>
              <li>मोरेटोरियम अवधि: 6 महीने तक पुनर्भुगतान की आवश्यकता नहीं।</li>
              <li>सीजीटीएमएसई कवरेज: राज्य सरकार द्वारा 4 वर्षों तक प्रदान किया जाएगा।</li>
              <li>मार्जिन मनी सब्सिडी: परियोजना लागत का 10% (अधिकतम ₹50,000 तक), जो यूनिट शुरू होने के बाद दिया जाएगा।</li>
            </ul>
            <strong>दूसरा चरण (Phase 2):</strong>
            <ul class="p-0 m-0">
              <li>पहले चरण का ऋण चुकाने के बाद, लाभार्थी दूसरे चरण में वित्तीय सहायता के लिए पात्र होंगे।</li>
              <li>परियोजना लागत अधिकतम ₹10 लाख हो सकती है; ₹10 लाख से अधिक 20 लाख की परियोजनाओं के लिए अतिरिक्त वित्तपोषण लाभार्थी को स्वयं करना होगा।</li>
              <li>ब्याज सब्सिडी: ₹7.5 लाख या पहले चरण के ऋण की दोगुनी राशि में से जो भी कम हो, उसका 50% ब्याज सब्सिडी, 3 वर्षों के लिए।</li>
              <li>सीजीटीएमएसई कवरेज: दूसरे चरण में भी 3 वर्षों तक राज्य सरकार द्वारा वहन किया जाएगा।</li>
              <li>मार्जिन मनी सब्सिडी: दूसरे चरण में उपलब्ध नहीं है।</li>
            </ul>
          </div>`
        },
        {
            id: '4',
            question: 'सीएम युवा के तहत मार्जिन मनी की आवश्यकता क्या है?',
            answer: `<ul class="p-0 m-0">
            <li>सामान्य श्रेणी (General): परियोजना लागत का 15%।</li>
            <li>ओबीसी (OBC): परियोजना लागत का 12.5%।</li>
            <li>एससी/एसटी, दिव्यांग और पिछड़े क्षेत्रों के लाभार्थी: परियोजना लागत का 10%।</li>
            <li>(पिछड़े क्षेत्र: बुंदेलखंड, पूर्वांचल, और आकांक्षी जिले (जैसे चितरकूट, चंदौली, सोनभद्र फतेहपुर, बलरामपुर, सिद्धार्थनगर, श्रावस्ती, बहराइच)।</li>
          </ul>`
        },
        {
            id: '5',
            question: 'क्या व्यवसाय के प्रकार पर कोई प्रतिबंध हैं?',
            answer: `<div>
            <p>हां, कुछ व्यवसायों को योजना के तहत वित्तीय सहायता के लिए अयोग्य घोषित किया गया है। नकारात्मक सूची में शामिल हैं:</p>
            <ul class="p-0 m-0">
              <li>शराब और पेय पदार्थ: ऐरेटेड (वातित पेय) और कार्बोनेटेड ड्रिंक्स सहित।</li>
              <li>तंबाकू उत्पाद: जैसे गुटखा और पान मसाला।</li>
              <li>पटाखे।</li>
              <li>प्लास्टिक बैग्स: 40 माइक्रोन से कम के।</li>
              <li>सरकार द्वारा निषिद्ध अन्य उत्पाद।</li>
            </ul>
          </div>`
        },
        {
            id: '6',
            question: 'क्या कोई अतिरिक्त लाभ हैं?',
            answer: '<p>हाँ, लाभार्थी प्रति डिजिटल लेनदेन पर ₹1 का अतिरिक्त अनुदान पाने के पात्र हैं, जिसकी अधिकतम सीमा ₹2,000 प्रति वर्ष है।</p>'
        },
        {
            id: '7',
            question: 'सीएम युवा के तहत ऋण प्रदान करने के लिए कौन सी वित्तीय संस्थाएँ पात्र हैं?',
            answer: '<p>ऋण प्रदान करने के लिए राष्ट्रीयकृत बैंक, अनुसूचित बैंक, ग्रामीण बैंक, आरबीआई द्वारा अनुमोदित अन्य वित्तीय संस्थाएँ पात्र हैं। राज्य सरकार इन संस्थानों के माध्यम से सब्सिडी और वित्तीय सहायता प्रदान करती है।</p>'
        },
        {
            id: '8',
            question: 'मैं इस योजना के लिए कैसे आवेदन कर सकता हूँ?',
            answer: `<ul class="p-0 m-0">
            <li>ऑनलाइन आवेदन: <a href="https://msme.up.gov.in">https://msme.up.gov.in</a> पर अपना आवेदन ऑनलाइन जमा करें।</li>
            <li>दस्तावेज अपलोड करें: आयु प्रमाण, शैक्षणिक योग्यता, कौशल प्रमाणपत्र (यदि लागू हो), बिजनेस प्लान, और पते का प्रमाण।</li>
            <li>ऋण प्रसंस्करण: बैंक प्रोजेक्ट का मूल्यांकन कर ऋण स्वीकृति या अस्वीकृति का निर्णय करेगा।</li>
            <li>सब्सिडी वितरण: ऋण स्वीकृत होने पर सब्सिडी और सहायता सीधे बैंक खाते में जमा होगी।</li>
          </ul>`
        }
    ];




    return (
        <>
            <Header />
            <>
                <main className="block-main bg-white">
                    <HeroSlider />

                    <section className='container sec-mt'>
                        <div className='row flex-wrap justify-content-center' style={{ gap: '16px' }}>
                            <div className='col-md-4 col-5 card-stl-2 bg-gra1'>
                                <div className='circular-icon'>
                                    {/* <IoIosCreate /> */}
                                    <img src={parcelIcon} alt="Parcel Icon" loading="lazy" />
                                </div>
                                <h3 className='hd-3'>{Math.floor((supplierStats?.suppliers || 0) / 100) * 100}+ Suppliers Registered</h3>
                                <a type="button" className="smp-round-btn ro-btn-white mt-3" target='_blank' href='https://cmyuva.org.in/ideation/supplier-connect' >
                                    VIEW ALL SUPPLIERS
                                </a>

                            </div>
                            <div className='col-md-4 col-5 card-stl-2 bg-gra2'>
                                <div className='circular-icon'>
                                    {/* <IoIosCreate /> */}
                                    <img src={cubesIcon} alt="Cube Icon" loading="lazy" />
                                </div>
                                <h3 className='hd-3'>{Math.floor((supplierStats?.supplierProducts || 0) / 100) * 100}+ Products Available</h3>
                                <a type="button" className="smp-round-btn ro-btn-theme mt-3" target='_blank' href='https://cmyuva.org.in/supplier-products' >
                                    VIEW ALL PRODUCTS
                                </a>

                            </div>
                        </div>
                    </section>

                    <section className='container sec-mt'>
                        <div className='row flex-wrap gap-md-2 gap-1 justify-content-center' style={{ }}>
                            <div className='col-12 mb-4'>
                                <h3 className='hd-2 text-center'>CMYuva के साथ क्यों जुड़ें?</h3>
                            </div>

                            <div className='col-md col-sm-6 col-10 card-stl-1'>
                                <img src={growthIcon} alt="Logo" loading="lazy" />
                                <h5 className='hd-4'>Increased Market Access</h5>
                                <p className='desc-2'>Connect with a wide range of buyers across industries.
                                    Gain visibility among potential clients looking for suppliers in your niche.</p>
                            </div>

                            <div className='col-md col card-stl-1'>
                                <img src={lightBulbIcon} alt="Logo" loading="lazy" />
                                <h5 className='hd-4'>Business Growth Opportunities</h5>
                                <p className='desc-2'>Access new orders and expand your customer base.Receive potential bulk orders from enterprises and government sectors.</p>
                            </div>

                            <div className='col-md col card-stl-1'>
                                <img src={shieldIcon} alt="Logo" loading="lazy" />
                                <h5 className='hd-4'>Enhanced Credibility</h5>
                                <p className='desc-2'>Being a registered supplier builds trust with potential buyers.A recognized supplier status can help in negotiations and contracts.</p>
                            </div>

                            <div className='col-md col-sm-6 col-10 card-stl-1'>
                                <img src={shuttleIcon} alt="Logo" loading="lazy" />
                                <h5 className='hd-4'>Networking & Collaboration</h5>
                                <p className='desc-2'>Opportunities to partner with other businesses.Exposure to industry trends and demands.</p>
                            </div>
                        </div>
                    </section>

                    <section className='sec-mt sec-py' style={{ backgroundColor: "var(--green-color)" }}>
                        <div className='container'>
                            <div className='row flex-wrap justify-content-center justify-content-md-start' style={{ gap: '16px' }}>
                                <div className='col-12 mb-2'>
                                    <h4 className='hd-3 text-center text-white'>Onboarding Process</h4>
                                </div>
                                <div className='col-md col-sm-4 col-5 card-stl-3 mb-4 mb-md-0' style={{ backgroundColor: '#FFE7E7' }}>
                                    <div className='circular-icon bg-gra1'><img src={userIcon} alt="Logo" loading="lazy" /></div>
                                    <h4 className='hd-4'>Onboard Yourself</h4>
                                    <span>STEP 01</span>
                                </div>
                                <div className='col-md col-sm-4 col-5 card-stl-3 mb-4 mb-md-0' style={{ backgroundColor: '#E4FCE9' }}>
                                    <div className='circular-icon bg-gra1'><img src={packageIcon} alt="Logo" loading="lazy" /></div>
                                    <h4 className='hd-4'>Onboard Your Product</h4>
                                    <span>STEP 02</span>
                                </div>
                                <div className='col-md col-sm-6 col-5 card-stl-3 ' style={{ backgroundColor: '#FFF1D3' }}>
                                    <div className='circular-icon bg-gra1'><img src={locationIcon} alt="Logo" loading="lazy" /></div>
                                    <h4 className='hd-4'>Onboard Your Location</h4>
                                    <span>STEP 03</span>
                                </div>
                                <div className='col-md col-sm col-5 card-stl-3 ' style={{ backgroundColor: '#E6F1FF' }}>
                                    <div className='circular-icon bg-gra1'><img src={cardIcon} alt="Logo" loading="lazy" /></div>
                                    <h4 className='hd-4'>Upload Your Bank Details</h4>
                                    <span>STEP 04</span>
                                </div>

                            </div>
                            <div className='row flex-wrap justify-content-center justify-content-md-start mt-5' style={{ gap: '16px' }}>
                                <div className='col-12 mb-2'>
                                    <h4 className='hd-3 text-center text-white'>How it Works?</h4>
                                </div>
                                <div className='col-md col-sm-4 col-5 card-stl-3 mb-4 mb-md-0' style={{ backgroundColor: '#F9F9F9' }}>
                                    <div className='circular-icon' style={{ backgroundColor: '#1F1F1F' }}><img src={verifyIcon} alt="Logo" loading="lazy" /></div>
                                    <h4 className='hd-4'>Receive Quotation</h4>
                                    <span>STEP 01</span>
                                </div>
                                <div className='col-md col-sm-4 col-5 card-stl-3 mb-4 mb-md-0' style={{ backgroundColor: '#F9F9F9' }}>
                                    <div className='circular-icon' style={{ backgroundColor: '#1F1F1F' }}><img src={newtworkIcon} alt="Logo" loading="lazy" /></div>
                                    <h4 className='hd-4'>Connect with customers</h4>
                                    <span>STEP 02</span>
                                </div>
                                <div className='col-md col-sm col-5 card-stl-3' style={{ backgroundColor: '#F9F9F9' }}>
                                    <div className='circular-icon' style={{ backgroundColor: '#1F1F1F' }}><img src={orderIcon} alt="Logo" loading="lazy" /></div>
                                    <h4 className='hd-4'>Send Product/Machinery Quotation</h4>
                                    <span>STEP 03</span>
                                </div>
                                <div className='col-md col-sm-6 col-5 card-stl-3' style={{ backgroundColor: '#F9F9F9' }}>
                                    <div className='circular-icon' style={{ backgroundColor: '#1F1F1F' }}><img src={verifyIcon} alt="Logo" loading="lazy" /></div>
                                    <h4 className='hd-4'>Update Order Status</h4>
                                    <span>STEP 04</span>
                                </div>
                            </div>
                            <div className='row mt-4'>
                                <div className='col-sm-5 col-10 d-flex justify-content-center mx-auto'>
                                    <a type="button" className="smp-round-btn ro-btn-theme mt-3" href='/Register' >
                                        Register Now </a>
                                </div>
                            </div>

                        </div>
                    </section>

                    <section className='container-fluid pb-4 mt-4 mt-sm-0'>
                        <div className='row'>
                            <div className='col-12 position-relative'>
                                <div className='ml-header-1' >
                                    <h3 className='hd-1 text-center'>Uttar Pradesh MSME Supplier Marketplace</h3>
                                    {/* <a type="button" className="smp-round-btn ro-btn-theme mt-3 mx-auto" href='/login' >
                                        VIEW ALL PRODUCTS/EQUIPMENT
                                    </a> */}

                                    <a
                                    type="button"
                                    className="round-btn ro-btn-theme mt-3 mx-auto "
                                    href='https://cmyuva.org.in/supplier-products'
                                    >
                                        <span><FaGear /></span>EXPLORE PRODUCTS/EQUIPMENT

                                    </a>

                                </div>

                                <a
                                    className='d-sm-block d-none'
                                    type="button"
                                    href='https://cmyuva.org.in/supplier-products'
                                >
                                    <img src={supplierBanner} className='img-fluid' alt='supplier banner' />
                                </a>

                                <a
                                    className='d-sm-none d-block'
                                    type="button"
                                    href='https://cmyuva.org.in/supplier-products'
                                >
                                    <img src={supplierMobileBanner} className='img-fluid' alt='supplier banner' />
                                </a>
                                
                                
                            </div>
                        </div>
                    </section>


                    <section id='FAQ-Section' className='sec-py' style={{ backgroundColor: "var(--light-gray-color)" }} >
                        <div className="container">
                            <div className='row'>
                                <div className='col-12'>
                                    <h3 className='hd-2 text-center'>FAQ's (अक्सर पूछे जाने वाले प्रश्न)</h3>
                                </div>
                                <div className='col-12'>
                                    <Accordion defaultActiveKey="0" className='accordionContainer'>
                                        <Accordion.Item eventKey="0" className='accordionItem'>
                                            <Accordion.Header className='accordionHeader'><h5 className='hd-4'>आपूर्तिकर्ता या फ्रेंचाइज़ी बनने के लिए कौन पात्र है?</h5></Accordion.Header>
                                            <Accordion.Body className='accordionContent'>
                                                <p className='desc-2'>कोई भी व्यवसाय या व्यक्ति जो उत्पाद या सेवाएँ प्रदान करता है, CMYuva पर पंजीकरण कर सकता है।</p>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className='accordionItem'>
                                            <Accordion.Header className='accordionHeader'>
                                                <h5 className='hd-4'>क्या पंजीकरण के लिए कोई शुल्क है?</h5>
                                            </Accordion.Header>
                                            <Accordion.Body className='accordionContent'>
                                                <p className='desc-2'>नहीं, वर्तमान में CMYuva पर आपूर्तिकर्ता या फ्रेंचाइज़ी पंजीकरण निःशुल्क है।</p>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2" className='accordionItem'>
                                            <Accordion.Header className='accordionHeader'>
                                                <h5 className='hd-4'>पंजीकरण के लिए आवश्यक दस्तावेज़?</h5>
                                            </Accordion.Header>
                                            <Accordion.Body className='accordionContent'>
                                                <p className='desc-2'>व्यवसाय पंजीकरण विवरण, जीएसटी प्रमाणपत्र (यदि लागू हो), और बैंक खाता जानकारी।</p>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3" className='accordionItem'>
                                            <Accordion.Header className='accordionHeader'>
                                                <h5 className='hd-4'>कोटेशन कैसे प्राप्त होंगे ?</h5>
                                            </Accordion.Header>
                                            <Accordion.Body className='accordionContent'>
                                                <p className='desc-2'> आवेदक द्वारा भरा गया कोटेशन अनुरोध आपके आपूर्तिकर्ता (supplier) डैशबोर्ड पर उपलब्ध होगा।</p>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </section>

                </main>
            </>
            <Footer />
        </>
    );
}